import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export function AuthCallback() {
  const { handleGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        const result = await handleGoogleCallback(sessionId);
        
        if (result.success) {
          // Redirect based on role
          const dashboardRoutes = {
            agency_admin: '/dashboard/admin',
            ceo: '/dashboard/ceo',
            caregiver: '/dashboard/caregiver',
            client: '/dashboard/client',
            family: '/dashboard/family',
            developer: '/dashboard/developer',
            potential_client: '/browse',
            job_seeker: '/jobs'
          };
          const path = dashboardRoutes[result.user.role] || '/';
          navigate(path, { replace: true, state: { user: result.user } });
        } else {
          navigate('/login', { replace: true, state: { error: result.error } });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-10 h-10 text-[#00A6A0] animate-spin" />
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
